/* eslint-disable react-hooks/exhaustive-deps */
import { getDateMonthString } from "components/CustomDatePicker/utils/helpers";
import { getTextByRangeMinutes } from "components/CustomTimePicker/utils";
import { useEffect, useState } from "react";
import NotificationVirtualAttendance from "views/components/AttendanceList/NotificationVirtualAttendance/NotificationVirtualAttendance";
import { Header } from "views/components/AttendanceList/styles";

const HeaderComponent = ({ eventData }) => {
	const {
		title,
		formattedDate: { manyDays, onlyDay },
		isPresential,
	} = eventData.value;
	const [scheduleOfDay, setScheduleOfDay] = useState({
		date: "-",
		time: "-",
	});
	useEffect(() => {
		if (!eventData.isLoaded) return;
		setScheduleOfDay({
			date: getScheduleOfDayDate(),
			time: getScheduleOfDayTime(),
		});
	}, [eventData.isLoaded]);
	function getScheduleOfDayDate() {
		if (onlyDay) return onlyDay;
		const dateObj = new Date(eventData.value.schedule.date);
		return getDateMonthString([dateObj.getMonth(), dateObj.getDate()], 1);
	}
	function getScheduleOfDayTime() {
		return getTextByRangeMinutes(eventData.value.schedule.time);
	}
	return (
		<Header>
			<h2>Asistencia de alumnos</h2>
			<h3>{title}</h3>
			{onlyDay && (
				<h4>
					<span>
						<strong>Fecha: </strong>
						{scheduleOfDay.date} / <strong>Hora: </strong>{" "}
						{scheduleOfDay.time}
					</span>
				</h4>
			)}
			{manyDays && (
				<>
					<h4>
						<span>
							<strong>Inicio: </strong>
							{manyDays.start}
						</span>
						<span>
							<strong>Finaliza: </strong>
							{manyDays.end}
						</span>
					</h4>
					<h4>
						<span>
							<strong>Día: </strong>
							{scheduleOfDay.date} / {scheduleOfDay.time}
						</span>
					</h4>
				</>
			)}
			{!isPresential && <NotificationVirtualAttendance />}
		</Header>
	);
};

export default HeaderComponent;
